import { render, staticRenderFns } from "./Func0.vue?vue&type=template&id=708cdc86"
import script from "./Func0.vue?vue&type=script&lang=js"
export * from "./Func0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports